import { render, staticRenderFns } from "./ShareLinkModalSuper.vue?vue&type=template&id=b351ba96&scoped=true"
import script from "./ShareLinkModalSuper.vue?vue&type=script&lang=js"
export * from "./ShareLinkModalSuper.vue?vue&type=script&lang=js"
import style0 from "./ShareLinkModalSuper.vue?vue&type=style&index=0&id=b351ba96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b351ba96",
  null
  
)

export default component.exports